import React, { Component } from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BasicLayout from "./pages/basicLayout";
import LoginPage from "./pages/login";

export default class App extends Component {
  render() {
    const theme = createMuiTheme({
      palette: {
        primary: {
          light: "#9945ff",
          main: "#6001d9",
          dark: "#1300a6",
          contrastText: "#fff",
        },
        secondary: {
          light: "#c4c4c4",
          main: "#949494",
          dark: "#666666",
          contrastText: "#fff",
        },
      },
    });

    return (
      <ThemeProvider theme={theme}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          pauseOnHover
        />
        <HashRouter>
          <Switch>
            <Route exact path="/" component={LoginPage} />
            <Route path="/admin" component={BasicLayout} />
            <Redirect to="/admin" />
          </Switch>
        </HashRouter>
      </ThemeProvider>
    );
  }
}
